import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_health" }, { title: "menu_sidebar_health_orders", link: "/health/orders" }];

const HealthOrderListing = Loadable({
  loader: () => import("container/health/order/listing"),
  loading() {
    return <Loader />;
  }
});

const HealthOrder = Loadable({
  loader: () => import("container/health/order"),
  loading() {
    return <Loader />;
  }
});

export const healthOrderRoutes: IRoute[] = [
  {
    path: "/health/orders",
    element: <HealthOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/health/orders/details/:id?",
    element: <HealthOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
